/* eslint-disable react-hooks/exhaustive-deps */
import Immutable from 'immutable';
import { useState, useEffect } from 'react';
import debugLog from 'core/utils/debugLog';

const _getStoredValue = (key, useImmutable = false) => {
  const storedData = global.localStorage.getItem(key);
  if (storedData) {
    try {
      const parsedData = JSON.parse(storedData);
      return useImmutable ? Immutable.fromJS(parsedData) : parsedData;
    } catch (error) {
      global.localStorage.removeItem(key);
      debugLog(
        'Error loading localStorage state, removing key',
        key,
        storedData,
        error
      );
    }
  }
};

export const useLocalStorage = (key, initialValue, isImmutable = false) => {
  const [state, setState] = useState(() => {
    const storedValue = _getStoredValue(key, isImmutable);

    if (typeof storedValue === 'undefined') {
      debugLog(
        'useLocalStorage: using initial value for state',
        key,
        initialValue
      );

      return initialValue;
    }
    return storedValue;
  });

  // Save the state to storage whenever the it changes
  useEffect(() => {
    const valueToStore =
      isImmutable && state && typeof state.toJS === 'function'
        ? state.toJS()
        : state;

    if (typeof valueToStore !== 'undefined' && valueToStore !== initialValue) {
      const stringifiedValue = JSON.stringify(valueToStore);
      debugLog(
        'useLocalStorage: state changed, saving to store',
        key,
        valueToStore
      );
      global.localStorage.setItem(key, stringifiedValue);
    }
  }, [state]);

  // Restore the state from storage whenever the key changes
  useEffect(() => {
    const storedValue = _getStoredValue(key, isImmutable);

    if (typeof storedValue !== 'undefined') {
      debugLog(
        'useLocalStorage: key changed, restoring from store',
        key,
        storedValue
      );
      setState(storedValue);
    }
  }, [key]);

  return [state, setState];
};
